import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ActionsForm from 'components/ActionsForm';
import { ActionState } from 'common';
import DetailsPanel from '../DetailsPanel';
import styles from './styles.css';
import messages from './messages';

/**
 * Create initial form values so checkmark inputs can initially
 * render in a state that indicates whether they are approved.
 * @param prescribedActionsData
 */
export const makeInitialValues = (prescribedActionsData) => {
  const initialValues = {};
  if (prescribedActionsData) {
    prescribedActionsData.forEach((action) => {
      initialValues[action.id] = action.status === ActionState.Approved;
    });
  }
  return initialValues;
};

const ActionsPanel = ({
  prescribedActionsData,
  hasActionResolvableByCurrentUser,
  handleSubmit,
  showCreateActionFormModal,
  showCreateActionButton,
}) => {
  const initialValues = makeInitialValues(prescribedActionsData);
  return (
    <DetailsPanel title={<FormattedMessage {...messages.actions} />}>
      <div className={styles.panel} data-test-handle="actionsPanel">
        <ActionsForm
          onSubmit={handleSubmit}
          actions={prescribedActionsData}
          initialValues={initialValues}
          hasActionResolvableByCurrentUser={hasActionResolvableByCurrentUser}
        />
      </div>
      {showCreateActionButton &&
      <button className={styles.showCreateActionFormLink} onClick={showCreateActionFormModal}>
        <FormattedMessage {...messages.createAction} />
      </button>
      }
    </DetailsPanel>
  );
};

ActionsPanel.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  prescribedActionsData: PropTypes.array.isRequired,
  hasActionResolvableByCurrentUser: PropTypes.bool.isRequired,
  showCreateActionFormModal: PropTypes.func.isRequired,
  showCreateActionButton: PropTypes.bool.isRequired,
};

export default ActionsPanel;



// WEBPACK FOOTER //
// ./src/components/ActionsPanel/index.js